/* ============================================================
   GET HIGH - CART DRAWER PRO (V19) 🚀
============================================================ */
const qs = (s) => document.querySelector(s);
let isManualClosing = false;

// 1. فتح وإغلاق السلة
window.openCartDrawer = function () {
  const drawer = qs('cart-drawer');
  const overlay = qs('#CartDrawer-Overlay');
  if (drawer && document.visibilityState === 'visible' && !isManualClosing) {
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('active');
    document.body.classList.add('overflow-hidden');
  }
};

window.closeCartDrawer = function () {
  isManualClosing = true;
  const drawer = qs('cart-drawer');
  const overlay = qs('#CartDrawer-Overlay');
  if (drawer) drawer.classList.remove('is-open');
  if (overlay) overlay.classList.remove('active');
  document.body.classList.remove('overflow-hidden');
  setTimeout(() => { isManualClosing = false; }, 800);
};

// 2. تحديث العدادات
window.updateFloatingCart = function () {
  fetch('/cart.js', { cache: 'no-cache' })
    .then(r => r.json())
    .then(cart => {
      const count = cart.item_count;
      const fCount = qs('.floating-cart__count');
      const fWrapper = qs('.floating-cart');

      // 🔑 إضافة: تحديث فقاعة السلة في الهيدر
      const drawerBubble = qs('.drawer-bubble');
      if (drawerBubble) {
        drawerBubble.textContent = count;
        drawerBubble.style.display = count > 0 ? 'flex' : 'none';
      }

      if (fCount) {
        fCount.textContent = count;
        fCount.style.display = count > 0 ? 'flex' : 'none';
      }
      if (fWrapper) {
        fWrapper.classList.toggle('floating-cart--hidden', count === 0);
      }
      if (count === 0 && !isManualClosing) window.closeCartDrawer();
    });
};

// 3. تحديث محتوى السلة
function refreshCart() {
  return fetch('/?sections=cart-drawer')
    .then(res => res.json())
    .then(data => {
      if (!data['cart-drawer']) return;
      const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      const drawerInner = qs('#CartDrawer-CartItems');
      const drawerFooter = qs('.drawer__footer');
      const newItems = html.querySelector('#CartDrawer-CartItems');
      const newFooter = html.querySelector('.drawer__footer');
      if (drawerInner && newItems) drawerInner.innerHTML = newItems.innerHTML;
      if (drawerFooter && newFooter) drawerFooter.innerHTML = newFooter.innerHTML;
      window.updateFloatingCart();

      // 🔑 الإضافة الجديدة - إخفاء الفوتر لما السلة تتفرغ
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          if (drawerFooter) {
            drawerFooter.style.display = cart.item_count === 0 ? 'none' : '';
          }
        });
    });
}

// 4. اعتراض fetch
(function interceptFetch() {
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
    const isAddToCart = url.includes('/cart/add');
    const promise = originalFetch.apply(this, args);
    if (isAddToCart) {
      promise.then(res => {
        if (res.ok) {
          refreshCart().then(() => {
            if (document.visibilityState === 'visible' && !isManualClosing) {
              window.openCartDrawer();
            }
          });
        }
        return res;
      }).catch(() => {});
    }
    return promise;
  };
})();

// 5. اعتراض XHR
(function interceptXHR() {
  const OriginalXHR = window.XMLHttpRequest;
  function PatchedXHR() {
    const xhr = new OriginalXHR();
    const originalOpen = xhr.open.bind(xhr);
    let isAddToCart = false;
    xhr.open = function (method, url, ...rest) {
      if (typeof url === 'string' && url.includes('/cart/add')) isAddToCart = true;
      return originalOpen(method, url, ...rest);
    };
    xhr.addEventListener('load', function () {
      if (isAddToCart && xhr.status >= 200 && xhr.status < 300) {
        refreshCart().then(() => {
          if (document.visibilityState === 'visible' && !isManualClosing) {
            window.openCartDrawer();
          }
        });
      }
    });
    return xhr;
  }
  PatchedXHR.prototype = OriginalXHR.prototype;
  window.XMLHttpRequest = PatchedXHR;
})();

// 6. أحداث الأزرار (إغلاق + كميات)
document.addEventListener('click', (e) => {
  // إغلاق السلة
  if (
    e.target.closest('.drawer__close') ||
    e.target.closest('#CartDrawer-Overlay') ||
    e.target.closest('.drawer-close-minimal')
  ) {
    window.closeCartDrawer();
    return;
  }

  const btn = e.target.closest('.plus-btn, .minus-btn, cart-remove-button, .cart-remove-button');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();

  const cartItem = btn.closest('[data-line], .cart-item');
  const rawLine = btn.dataset?.line || cartItem?.dataset?.line || '';

  if (!rawLine) { refreshCart(); return; }

  const variantId = rawLine.includes(':') ? rawLine.split(':')[0] : rawLine;
  const isDelete = btn.tagName === 'CART-REMOVE-BUTTON' || btn.classList.contains('cart-remove-button');

  if (isDelete) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 0 }),
    }).then(() => refreshCart()).catch(() => refreshCart());
    return;
  }

  // نجيب الكمية الحالية من السلة الحقيقية
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const item = cart.items.find(i => String(i.variant_id) === String(variantId));
      const currentQty = item ? item.quantity : 1;

      let newQty = currentQty;
      if (btn.classList.contains('plus-btn')) newQty = currentQty + 1;
      else if (btn.classList.contains('minus-btn')) newQty = Math.max(0, currentQty - 1);

      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: newQty }),
      });
    })
    .then(() => refreshCart())
    .catch(() => refreshCart());
});